import type { ScheduleSlot } from '@brighterly/lib-core-types/booking/interfaces'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export interface ParsedSlot {
  value: string
  text: string
}

export const useAvailableSlotsParser = () => {
  const parseTimeSlots = (slots: string[]): ParsedSlot[] => {
    return slots.map(slot => ({
      value: slot,
      text: dayjs(`2000-01-01 ${slot}`, `${DateFormat.DefaultDate} ${DateFormat.DefaultTime}`).format(DateFormat.BookedTime),
    }))
  }

  const getAvailableDates = (availableSlots: ScheduleSlot[]): Date[] => {
    return availableSlots.map(slot => new Date(slot.day))
  }

  const getDisabledDates = (availableSlots: ScheduleSlot[], minDate: Date, maxDate: Date): Date[] => {
    const availableDatesSet = new Set(availableSlots.map(slot => slot.day))

    const disabled: Date[] = []

    let current = dayjs(minDate)
    const end = dayjs(maxDate)

    while (current.isBefore(end) || current.isSame(end, 'day')) { // FIXME: while
      const dateStr = current.format(DateFormat.DefaultDate)
      if (!availableDatesSet.has(dateStr)) {
        disabled.push(current.toDate())
      }
      current = current.add(1, 'day')
    }

    return disabled
  }

  return {
    parseTimeSlots,
    getAvailableDates,
    getDisabledDates,
  }
}
